module.exports = "<inscricao-filtro> </inscricao-filtro>\n\n<br>\n\n<inscricao-list [ehAdmin]=\"true\"> </inscricao-list>\n"